import { createPortal } from 'react-dom'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import PropTypes from 'prop-types'

// Custom Components
import { TableViewOnly } from '../../components/table/Table'

// Store
import { HIDE_CANVAS_DIALOG, SHOW_CANVAS_DIALOG } from '../../store/actions'
import { baseURL } from '../../store/constant'

// API
import configApi from '../../api/config'
import useApi from '../../hooks/useApi'

interface NodeInfoDialogProps {
    show: boolean;
    dialogProps: any;
    onCancel: () => void;
}

const NodeInfoDialog: React.FC<NodeInfoDialogProps> = ({ show, dialogProps, onCancel }) => {
    const portalElement = document.getElementById('portal')
    const dispatch = useDispatch()

    const getNodeConfigApi: any = useApi(configApi.getNodeConfig)

    useEffect(() => {
        if (dialogProps.data) {
            getNodeConfigApi.request(dialogProps.data)
        }
    }, [dialogProps, getNodeConfigApi])

    useEffect(() => {
        if (show) {
            dispatch({ type: SHOW_CANVAS_DIALOG });
        } else {
            dispatch({ type: HIDE_CANVAS_DIALOG });
        }
        return () => {
            dispatch({ type: HIDE_CANVAS_DIALOG });
        };
    }, [show, dispatch]);

    const component = show ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black bg-opacity-50">
            <div className="bg-white w-full max-w-3xl mx-auto rounded-lg shadow-lg">
                <div className="p-4 border-b">
                    {dialogProps.data && dialogProps.data.name && dialogProps.data.label && (
                        <div className="flex items-center">
                            <div className="w-12 h-12 mr-2 rounded-full bg-white">
                                <img
                                    className="w-full h-full p-2 rounded-full object-contain"
                                    alt={dialogProps.data.name}
                                    src={`${baseURL}/api/v1/node-icon/${dialogProps.data.name}`}
                                />
                            </div>
                            <div className="flex flex-col ml-2">
                                {dialogProps.data.label}
                                <div className="flex">
                                    <div className="flex items-center px-2 py-1 mt-1 mr-2 text-xs text-yellow-800 bg-yellow-200 rounded-full">
                                        {dialogProps.data.id}
                                    </div>
                                    {dialogProps.data.version && (
                                        <div className="flex items-center px-2 py-1 mt-1 text-xs text-green-800 bg-green-200 rounded-full">
                                            version {dialogProps.data.version}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="p-4">
                    {dialogProps.data?.description && (
                        <div className="p-2 mb-2">
                            <span>{dialogProps.data.description}</span>
                        </div>
                    )}
                    {getNodeConfigApi.data && getNodeConfigApi.data.length > 0 && (
                        <TableViewOnly rows={getNodeConfigApi.data} columns={Object.keys(getNodeConfigApi.data[0]).slice(-3)} />
                    )}
                </div>
                <div className="p-4 border-t">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2 text-sm text-white bg-blue-500 rounded-full hover:bg-blue-600 focus:outline-none"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    ) : null
    if (!portalElement) return null;
    return createPortal(component, portalElement)
}

NodeInfoDialog.propTypes = {
    show: PropTypes.bool.isRequired,
    dialogProps: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
}

export default NodeInfoDialog
